// ============================================
// Path: /frontend/src/components/InquiryModal.jsx
// Purpose: Modal for users to send inquiries with messages
// ============================================

import { useState } from 'react';
import { Button } from './ui/button';
import { Textarea } from './ui/textarea';
import { Label } from './ui/label';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from './ui/dialog';
import { Loader2 } from 'lucide-react';

export function InquiryModal({ isOpen, onClose, onSubmit, listingTitle, isSubmitting }) {
  const [message, setMessage] = useState('');

  const handleSubmit = () => {
    onSubmit(message);
    setMessage(''); // Clear after submit
  };

  const handleClose = () => {
    setMessage(''); // Clear on close
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle>Send Inquiry</DialogTitle>
          <DialogDescription>
            Send a message to the seller about: <strong>{listingTitle}</strong>
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="message">Your Message (Optional)</Label>
            <Textarea
              id="message"
              placeholder="Hi, I'm interested in this listing. Is it still available?"
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              rows={5}
              maxLength={1000}
              className="resize-none"
            />
            <p className="text-xs text-muted-foreground">
              {message.length}/1000 characters
            </p>
          </div>
          <p className="text-sm text-muted-foreground">
            The seller will receive your contact information along with this message.
          </p>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={handleClose} disabled={isSubmitting}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} disabled={isSubmitting}>
            {isSubmitting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Send Inquiry
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}